import { booleanAttribute, ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { CustomerVehicle, CustomerVehicleRelationType } from '../../../customer/model/customer-vehicle.model';
import { useI18n } from '../../../i18n/services/i18n.service';
import { CustomerVehicleRelationsComponent } from '../customer-vehicle-relations/customer-vehicle-relations.component';
import { RelationButtonConfig } from '../customer-vehicle-relations/relation-button-config';
import { CountryLicensePlateContainer } from '../license-plate/country-license-plate.container';
import { VehicleImageContainer } from '../vehicle-image/vehicle-image.container';
import { VinComponent } from '../vin/vin.component';

@Component({
  selector: 'cdf-vehicle-info',
  imports: [CustomerVehicleRelationsComponent, VinComponent, VehicleImageContainer, CountryLicensePlateContainer],
  host: {
    '[class.small-image]': 'smallImage()',
  },
  template: `
    <cdf-vehicle-image [vin]="vehicle().vin" />
    <div class="d-flex flex-column gap-1x vehicle-data">
      <div class="d-flex flex-row gapx-2x flex-wrap">
        <div class="vehicle-name">{{ vehicle().name ?? i18n('vehicles.modelUnknown') }}</div>
        <cdf-customer-vehicle-relations
          [relationTypes]="vehicle().relationTypes"
          [markRelationDestructive]="markRelationDestructive()"
          [removeButton]="removeButton()"
          [addButton]="addButton()"
          [truncate]="truncateRelations()"
          (removeRelation)="removeRelation.emit($event)"
          (addRelation)="addRelation.emit()"
        />
      </div>
      <cdf-vin class="text-neutral" [vin]="vehicle().vin" />
      @if (vehicle().licensePlate || canEditLicensePlate()) {
        <cdf-country-license-plate
          [licensePlate]="vehicle().licensePlate"
          [country]="activeCountry()"
          [canEdit]="canEditLicensePlate()"
          (editLicensePlate)="editLicensePlate.emit()"
        />
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: 'vehicle-info.component.scss',
})
export class VehicleInfoComponent {
  protected readonly i18n = useI18n();

  readonly vehicle = input.required<CustomerVehicle>();
  readonly activeCountry = input<string | undefined>();
  readonly markRelationDestructive = input<CustomerVehicleRelationType | undefined>(undefined);
  readonly removeButton = input<RelationButtonConfig>();
  readonly addButton = input<RelationButtonConfig>();
  readonly truncateRelations = input(false, { transform: booleanAttribute });
  readonly smallImage = input(false, { transform: booleanAttribute });
  readonly canEditLicensePlate = input(false, { transform: booleanAttribute });

  readonly removeRelation = output<CustomerVehicleRelationType>();
  readonly addRelation = output();
  readonly editLicensePlate = output();
}
